var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"mode":"out-in","name":"fade"}},[(_vm.isShowing)?_c('div',{staticClass:"overlayer"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-spinner'),_c('p',[_vm._v("Carregando..")])],1)],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }